import moment from 'moment';
import queryString from 'qs';

const getReportBrandRequest = (queryParams) => {
  const queries = { limit: 10, page: queryParams?.page };

  if (queryParams?.brand?.startedAt) queries['startedAt'] = moment(queryParams?.brand?.startedAt).format('YYYY-MM-DD');
  if (queryParams?.brand?.endedAt) queries['endedAt'] = moment(queryParams?.brand?.endedAt).format('YYYY-MM-DD');
  if (queryParams?.brand?.brand?.length) queries['brandName'] = `[${queryParams?.brand?.brand?.map((item) => item?.value)}]`;
  if (queryParams?.search) queries['search'] = queryParams?.search;
  if (queryParams?.sort) queries['sort'] = `${queryParams?.sort?.field}.${queryParams?.sort?.order}`;

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getReportBrandRequest;
